import Vue from 'vue'
import Vuex from 'vuex'
import culIndex from './culIndex'
import culCharacter from './culCharacter'
import culDisplay from './culDisplay'
const kuromoji = require('kuromoji')
const dictPath = './dict'
let tokenizer = null
Vue.use(Vuex)

const state = {
    resultSurf: { surf: [], pos1: [], pos2: [] },
    watchPos1Check: [],
    watchPos2Check: [],
    indexPosList: { pos1: '', pos2: '' },
    isLoadingFlg: true,
    isZenAnalyse: false,
    isSearchMode: 0,
    isHiSpeed: true,
    isNumberSort: false,
    checkIndex: [],
    dspPosCheckBox: { pos1: '', pos2: '' },
    dspPosList: { single: '', multiple: '' },
    convertList: [{ label: '一括', value: 'all' }, { label: '英数', value: 'ltrNum' }, { label: '記号', value: 'symbol' }, { label: 'カナ', value: 'kana' }, { label: '空白', value: 'space' }],
    convertSelected: [{ zenkaku: [] }, { hankaku: [] }],
    replaceText: { search: '', replace: '' },
    searchText: '',
}

const getters = {
  watchPos1Check: state => { return state.watchPos1Check },
  watchPos2Check: state => { return state.watchPos2Check },
}

const mutations = {
    torken (state) {
      kuromoji.builder({ dicPath: dictPath }).build((err, token) => {
        if (err) throw err
        else {
          tokenizer = token
          state.isLoadingFlg = false
        }
      })
    },

    analyseDoc (state, textData) {
      // インプットテキスト=>半角全角変換
      textData = (state.isZenAnalyse === true) ? culCharacter.han2ZenAll(textData) : textData
      // 文字列の形態素解析※非同期なのでその後の処理もここに記載※辞書がなかったりするとここでエラーになる
      // 文字列を渡して形態素解析=>改行コードを削除(?は0または1回という意味のため\r\nと\nを削除、CRには非対応)
      textData = textData.split(/\r?\n/g)
      // 初期化
      state.resultSurf.surf = []
      state.resultSurf.pos1 = []
      state.resultSurf.pos2 = []
      // 形態素解析
      for (const pick of textData) {
        const tokens = tokenizer.tokenize(pick)
        // 形態素解析結果の格納
        state.resultSurf.surf = state.resultSurf.surf.concat(tokens.map((token) => { return token.surface_form }))
        state.resultSurf.pos1 = state.resultSurf.pos1.concat(tokens.map((token) => { return token.pos }))
        state.resultSurf.pos2 = state.resultSurf.pos2.concat(tokens.map((token) => { return token.pos_detail_1 }))
        state.resultSurf.surf.push('<br>')
        state.resultSurf.pos1.push('改行')
        state.resultSurf.pos2.push('改行')
      }
      // ---ここから形態要素解析の事後処理---
      state.resultSurf.pos1 = culCharacter.amendError(state.resultSurf.surf, state.resultSurf.pos1)
      // 品詞の重複排除後、品詞のチェックボックスの生成
      state.dspPosCheckBox.pos1 = culIndex.deduplicate(state.resultSurf.pos1).filter(n => n !== '改行')
      state.dspPosCheckBox.pos2 = culIndex.deduplicate(state.resultSurf.pos2).filter(n => n !== '改行')
    },

    checkReset () {
      state.watchPos1Check = []
      state.watchPos2Check = []
    },

    reDisplay () {
      state.checkIndex = culIndex.getCheckIndexList(state.indexPosList.pos1, state.indexPosList.pos2, state.resultSurf.pos1, state.resultSurf.pos2)
      state.dspPosList.single = culDisplay.getSinglePosDocList(state.checkIndex, state.resultSurf.surf, state.isNumberSort)
      state.dspPosList.multiple = culDisplay.getContPosDocList(state.checkIndex, state.resultSurf.surf, state.isNumberSort)
      this.commit('changeEdtorHTML', culDisplay.changeDocColor(state.checkIndex, state.resultSurf.surf, this.state.darkTheme, state.isHiSpeed))
    },

    async watchPos1Check () {
      // state.isDisplayDoc = 'none'
      await this.commit('partAnalysis/analyseDoc', this.state.memNowDoc)
      state.indexPosList.pos1 = state.watchPos1Check.map(item => { return item })
      await this.commit('partAnalysis/reDisplay')
      // state.isDisplayDoc = 'inherit'
    },

    async watchPos2Check () {
      // state.isDisplayDoc = 'none'
      await this.commit('partAnalysis/analyseDoc', this.state.memNowDoc)
      state.indexPosList.pos2 = state.watchPos2Check.map(item => { return item })
      await this.commit('partAnalysis/reDisplay')
      // state.isDisplayDoc = 'inherit'
    },

    convertZenkaku () {
      // %09はタブ、改行後の半角スペースはuA0（半角スペースの別のunicode）として読み込まれることがある。これを一括変換
      let preProcessing = this.state.memNowDoc
      preProcessing = (state.convertSelected.zenkaku === 'all') ? culCharacter.han2ZenAll(preProcessing)
      : (state.convertSelected.zenkaku === 'ltrNum') ? culCharacter.han2ZenLtrNum(preProcessing)
      : (state.convertSelected.zenkaku === 'symbol') ? culCharacter.han2ZenSign(preProcessing)
      : (state.convertSelected.zenkaku === 'kana') ? culCharacter.han2ZenKana(preProcessing)
      : (state.convertSelected.zenkaku === 'space') ? preProcessing.replace(/[\x20]/g, '　') : preProcessing
      this.commit('changeEdtorHTML', preProcessing)
    },

    convertHankaku () {
      // %09はタブ、改行後の半角スペースはuA0（半角スペースの別のunicode）として読み込まれることがある。これを一括変換
      let preProcessing = this.state.memNowDoc
      preProcessing = (state.convertSelected.hankaku === 'all') ? culCharacter.zen2HanAll(preProcessing)
      : (state.convertSelected.hankaku === 'ltrNum') ? culCharacter.zen2HanLtrNum(preProcessing)
      : (state.convertSelected.hankaku === 'symbol') ? culCharacter.zen2HanSign(preProcessing)
      : (state.convertSelected.hankaku === 'kana') ? culCharacter.zen2HanKana(preProcessing)
      : (state.convertSelected.hankaku === 'space') ? preProcessing.replace(/[\x20]/g, '　') : preProcessing
      this.commit('changeEdtorHTML', preProcessing)
    },

    replaceAll () {
      const egExp = new RegExp(state.replaceText.search, 'g')
      this.commit('changeEdtorHTML', this.state.memNowDoc.replace(egExp, state.replaceText.replace))
    },

    searchAct () {
      // 重複排除とソート
      if (state.isSearchMode === 0) state.checkIndex = culIndex.getSchIndexOnly(state.resultSurf.surf, state.checkIndex, state.searchText)
      else state.checkIndex = culIndex.getSchIndex(state.resultSurf.surf, state.checkIndex, state.searchText)
      // 表示処理
      this.commit('changeEdtorHTML', culDisplay.changeDocColor(state.checkIndex, state.resultSurf.surf, this.state.darkTheme))
      state.dspPosList.single = culDisplay.getSinglePosDocList(state.checkIndex, state.resultSurf.surf, state.isNumberSort)
      state.dspPosList.multiple = culDisplay.getContPosDocList(state.checkIndex, state.resultSurf.surf, state.isNumberSort)
    },
}

export default {
  namespaced: true,
  getters,
  state,
  mutations,
}
